import React, {Component} from "react"
import { Table, Row, Pagination } from "antd"
import "./Index.scss"
import downloadIcon from "app/styles/images/sp/download.svg"
import warningIcon from "app/styles/images/sp/data-warning.svg"
import FlexableFileName from "app/components/normal/FlexableFileName"
import config from "app/config"

import { PREPARE_RUN, RUNNING } from 'app/utils/const'

export default class ReportDetail extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpenImg1: false,
      isOpenImg2: false,
      activeReportIndex: 0,
      currentPage:1,
      reportListArr:[],
    }
  }

  componentWillMount() {
    this.initNav(this.props.index)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.index !== this.props.index) {
      this.initNav(nextProps.index)
    }
  }

  initNav = (index) => {
    this.setState({
      activeReportIndex: index,
      currentPage: Math.floor(index / 10) + 1
    })
  }

  isEmptyObj = (obj) => {
    return Object.keys(obj).length === 0
  }

  changeReport = (index, record) => {
    this.refs.content.scrollTop = 0
    this.setState({
      activeReportIndex:index
    })
    this.props.dataSwitch(index, record)
  }

  changePage = (e) => {
    let activeReportIndex = (e-1) * 10
    let record = this.props.reportList[activeReportIndex]

    this.renderReportList(e)
    this.setState({
      currentPage:e,
      activeReportIndex
    })
    this.changeReport(activeReportIndex, record)
  }

  renderReportList = (pageNumber) => {
    let { reportList } = this.props.data
    let reportListArr = []
    let endNum = pageNumber * 10
    if (endNum > reportList.length) {
      endNum = reportList.length
    }
    for (let currenNum = (pageNumber - 1) * 10; currenNum < endNum; currenNum++) {
      const { state } = reportList[currenNum]

      if (state !== PREPARE_RUN && state !== RUNNING) {
        reportListArr.push(
          <li
            key={currenNum}
            onClick={() => this.changeReport(currenNum, reportList[currenNum])}
            className={ this.state.activeReportIndex === currenNum ? "active report" : "report"}
          >
            {reportList[currenNum].sampleName}
          </li>
        )
      }
    }
    return reportListArr
  }

  /**
   * 解析文本中的 \n 为虚拟 <br /> 结点
   */
  parseEnter (str) {
    if (!str || typeof str !== "string") {
      return null
    }

    const strs = str.split("\n")
    const result = []

    for (var i = 0; i < strs.length - 1; i++) {
      result.push(strs[i], <br />)
    }
    return result
  }

  render() {
    const {
      currentPage,
    } = this.state
    let { data = {}, reportDetail } = this.props
    let dataColumns = []
    // const renderContent = (text, record, index) => {
    //   const obj = {
    //     children: text,
    //     props: {},
    //   }
    //   if (record.state === PREPARE_RUN || record.state === RUNNING || record.state === FAIL) {
    //     obj.props.colSpan = 0
    //   }
    //   return obj
    // }

    // if (data.reportList === undefined) {
    //     data.reportList = []
    // } else {
    //   if(!this.isEmptyObj(reportDetail) && reportDetail["statistical"]){
        dataColumns = [
          {
            title: (<div className="ta-c">Total Reads</div>),
            className: "ta-c",
            dataIndex: "Total Reads",
          }, {
            title: (<div className="ta-c">High Quality(%)</div>),
            className: "ta-c",
            dataIndex: "High Quality(%)",
          }, {
            title: (<div className="ta-c">Mapping Rate(%)</div>),
            className: "ta-c",
            dataIndex: "Mapping Rate(%)",
          }, {
            title: (<div className="ta-c">GC(%)</div>),
            className: "ta-c",
            dataIndex: "GC(%)",
          }, {
            title: (<div className="ta-c">Library Quality</div>),
            className: "ta-c",
            dataIndex: "Library Quality",
          }
        ]
        data.appName === 'AZF_PGM' ? dataColumns.splice(1, 0, {
          title: (<div className="ta-c">Average Length</div>),
          className: "ta-c",
          dataIndex: "Average Length",
        }) : dataColumns.splice(1, 0, {
          title: (<div className="ta-c">Trimmomatic Ratio</div>),
          className: "ta-c",
          dataIndex: "Trimmomatic Ratio",
        })
    //   }
    // }

    const sampleInfoColumns = [
      {
        title: "Number",
        dataIndex: "id",
        width: 150,
      }, {
        title: "Sample Name",
        dataIndex: "sampleName",
        width: 150,
      }, {
        title: "Filename",
        dataIndex: "filename",
        width: 150,
        render: (text) => (
          <FlexableFileName
            filename={text}
          />
        )
      }, {
        title: "Reference",
        dataIndex: "reference",
        width: 150,
        render: (text) => {
          return (
            <div>{text ? "是" : "否"}</div>
          )
        }
      }
    ]
    const PGM_STSColumns = [
      {
        title: "sY84",
        dataIndex: "sY84",
        width: 150,
      },
      {
        title: "sY86",
        dataIndex: "sY86",
        width: 150,
      },
      {
        title: "sY127",
        dataIndex: "sY127",
        width: 150,
      },
      {
        title: "sY134",
        dataIndex: "sY134",
        width: 150,
      },
      {
        title: "sY1191",
        dataIndex: "sY1191",
        width: 150,
      },
      {
        title: "sY254",
        dataIndex: "sY254",
        width: 150,
      },
      {
        title: "sY255",
        dataIndex: "sY255",
        width: 150,
      },
      {
        title: "sY255_sY254",
        dataIndex: "sY255_sY254",
        width: 150,
      }
    ]
    const STSColumns = [
      {
        title: "EHMT1",
        dataIndex: "EHMT1",
        width: 150,
      },
      {
        title: "ZFX",
        dataIndex: "ZFX",
        width: 150,
      },
      {
        title: "ZFY",
        dataIndex: "ZFY",
        width: 150,
      },
      {
        title: "SRY",
        dataIndex: "SRY",
        width: 150,
      },
      {
        title: "sY82",
        dataIndex: "sY82",
        width: 150,
      },
      {
        title: "sY1064",
        dataIndex: "sY1064",
        width: 150,
      },
      {
        title: "sY86",
        dataIndex: "sY86",
        width: 150,
      },
      {
        title: "sY84",
        dataIndex: "sY84",
        width: 150,
      },
      {
        title: "sY1065",
        dataIndex: "sY1065",
        width: 150,
      },
      {
        title: "sY88",
        dataIndex: "sY88",
        width: 150,
      },
      {
        title: "sY105",
        dataIndex: "sY105",
        width: 150,
      },
      {
        title: "sY121",
        dataIndex: "sY121",
        width: 150,
      },
      {
        title: "sY124",
        dataIndex: "sY124",
        width: 150,
      },
      {
        title: "sY127",
        dataIndex: "sY127",
        width: 150,
      },
      {
        title: "sY134",
        dataIndex: "sY134",
        width: 150,
      },
      {
        title: "sY1192",
        dataIndex: "sY1192",
        width: 150,
      },
      {
        title: "sY1191",
        dataIndex: "sY1191",
        width: 150,
      },
      {
        title: "sY153",
        dataIndex: "sY153",
        width: 150,
      },
      {
        title: "sY255",
        dataIndex: "sY255",
        width: 150,
      },
      {
        title: "sY254",
        dataIndex: "sY254",
        width: 150,
      },
      {
        title: "sY157",
        dataIndex: "sY157",
        width: 150,
      },
      {
        title: "sY160",
        dataIndex: "sY160",
        width: 150,
      }
    ]

    return (
      <Row type="flex" className="azf-report-detail">
        <div ref="content" className="content">
          <div id="detailTop" className="detail-card border-left-paimary first">
            <div className="info-group">
              <label>数据类型：</label>
              <p>{data ? data.appName : ""}</p>
            </div>
            <div className="info-group">
              <label>所在分组：</label>
              <p>{data.groupName}</p>
            </div>
          </div>

          <div className="detail-card">
            <h3 className="border-left-primary detail-card-title">The information of sample</h3>
            <Table
              className="azf-sample-info-table"
              columns={sampleInfoColumns}
              rowKey={record=>record.id+ "sample-info"}
              dataSource={!this.isEmptyObj(reportDetail) ? reportDetail.datas : []}
              pagination={false}
            />
            {
              (!this.isEmptyObj(reportDetail) && reportDetail.qualityState !== 0)  // 质控通过不渲染  不通过才渲染
              && (
                <div className="qc-content">
                  <img className="warning-icon" src={warningIcon} alt="" />
                  {reportDetail.qualityContent}
                </div>
              )
            }
          </div>

          <div className="detail-card">
            <h3 className="border-left-primary detail-card-title">
              <a>The statistics of data</a>
            </h3>
            <Table
              columns={dataColumns}
              rowKey={record => record.id + "statistical"}
              dataSource={
                (!this.isEmptyObj(reportDetail) && Object.keys(reportDetail.statistical).length > 0)
                  ? [reportDetail.statistical] : []
              }
              pagination={false}
            />
          </div>

          <div className="detail-card">
            <h3 className="border-left-primary detail-card-title">
              The Result
            </h3>
            <div className="font-14">
              {
                !this.isEmptyObj(reportDetail) && (this.parseEnter(reportDetail.result) || "暂无结果")
              }
            </div>
          </div>

          <div className="detail-card">
            <h3 className="border-left-primary detail-card-title">
              The signal value of STS
            </h3>
            {(data && data.appName === 'AZF_PGM') && (
              <Table
                columns={PGM_STSColumns}
                rowKey={record=>record.id + "sts"}
                dataSource={
                  (!this.isEmptyObj(reportDetail) && (!this.isEmptyObj(reportDetail.sts)) ? [reportDetail.sts] : [])
                }
                pagination={false}
              />
            )}  
            {(data && data.appName === 'AZF_Miseq') && (
              <div>
                <Table
                  columns={STSColumns.slice(0, 11)}
                  rowKey={record=>record.id + "sts"}
                  dataSource={
                    (!this.isEmptyObj(reportDetail) && (!this.isEmptyObj(reportDetail.sts)) ? [reportDetail.sts] : [])
                  }
                  pagination={false}
                />
                <Table
                  columns={STSColumns.slice(11)}
                  rowKey={record=>record.id + "sts"}
                  dataSource={
                    (!this.isEmptyObj(reportDetail) && (!this.isEmptyObj(reportDetail.sts)) ? [reportDetail.sts] : [])
                  }
                  pagination={false}
                />
              </div>
            )}
           
          </div>

          <div className="detail-card">
            <h3 className="border-left-primary detail-card-title">
              The adjusted Reads count of STS
            </h3>
            <div>
              <img alt="" src={!this.isEmptyObj(reportDetail) ? reportDetail.image.ReportInfoProbe : []} />
            </div>
          </div>

          <div className="detail-card">
            <h3 className="border-left-primary detail-card-title">
              The copy variation value of blocks
            </h3>
            <div>
              <img alt="" src={!this.isEmptyObj(reportDetail) ? reportDetail.image.ReportInfoBlock : []} />
            </div>
          </div>

          <div className="detail-card">
            <h3 className="border-left-primary detail-card-title">
              The copy number of probes
            </h3>
            <div>
              <img alt="" src={!this.isEmptyObj(reportDetail) ? reportDetail.image.ReportInfoPre : []} />
            </div>
          </div>

          <div className="detail-card">
            <h3 className="border-left-primary detail-card-title">
              运行信息
            </h3>
            <div>
              <div className="font-14">
                <span className="blue-text">taskId：</span>{!this.isEmptyObj(reportDetail) ? reportDetail.taskId : ""}
              </div>
              <div className="font-14">
                <span className="blue-text">reportId：</span>
                {!this.isEmptyObj(reportDetail) ? reportDetail.reportId : ""}
              </div>
            </div>
          </div>

          <div className="wrapper-download">
            <a
              href={`${config.backend}/azf/reports/${!this.isEmptyObj(reportDetail) && reportDetail.reportId}/download`}
              title="下载报告"
              className="download"
            >
              <img src={downloadIcon} alt="下载"/>
            </a>
          </div>
        </div>
        <div className="reportNav">
          <div className="title">本组数据</div>
          <ul className="reports">
            {data.reportList && this.renderReportList(currentPage)}
          </ul>
          <Pagination
            className="pagination"
            size="small"
            pageSize={10}
            total={
              (data.reportList || []).filter(item =>
                item.state !== PREPARE_RUN && item.state !== RUNNING
              ).length
            }
            current={currentPage}
            onChange={ (e) => this.changePage(e) }
          />
        </div>
      </Row>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/normal/azf/ReportDetail/index.js